import React, { useEffect, useState, useRef } from "react";
import {
  Modal,
  Button,
  Menu,
  Dropdown,
  Radio,
  Space,
  Spin,
  Select,
  Switch,
} from "antd";
import Profile from "../../../../assets/Sidebar/Profile_Pic.svg";
import {
  getShareableId,
  setSharableId,
  setShareableModifyUserData,
  setDefaultSharableUserData,
  setSharableUserData,
} from "../../../../redux/actions/ApiCall/apiCall";
import { useDispatch, useSelector } from "react-redux";
import accoArrow from "../../../../assets/acco_arrow-up.svg";
import accoArrowWhite from "../../../../assets/WhiteIcons/acco_arrow-upWhite.svg";
import { setGraphPageBrandValue } from "../../../../redux/actions/Template";
import {
  resetSelectedProfileInfoInShareModal,
  setSharedBrands,
} from "../../../../redux/actions/share/Share";
import ShareDropdown from "./ShareDropdown";
import SendModal from "./SendModal";
import SharePassword from "./SharePassword";
import { LoadingOutlined } from "@ant-design/icons";
import BackArrow from "../../../../assets/BackArrow.svg";
import {
  getPaneIndex,
  getTemplateListBasicObject,
} from "../../../../redux/constants";
import logo from "../../../../assets/Locobuzz_Blue_Logo.svg";
import { memo } from "react";

const ShareModal = (props) => {
  const dispatch = useDispatch();
  const [valuePassword, setValuePassword] = useState(1);
  const [shareableLink, setShareableLink] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const shareableData = useSelector((state) => state.dashboard.shareableData);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const shareableUrl = useSelector((state) => state.ApiCall.shareableLink);
  const sharedBrands = useSelector((state) => state.Share.sharedBrands);
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );

  const selectBrandValue = useSelector(
    (state) => state.Template.selectBrandValue
  ); // selected brand values
  const brandCheckedItems = useSelector(
    (state) => state.Template.brandCheckedItems
  ); //checked brand values
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  let index = getPaneIndex(panes, activeKey);

  const defaultShareableUserData = useSelector(
    (state) => state.ApiCall.defaultShareableUserData
  );
  const sharedWithTeamOwnerData = useSelector(
    (state) => state?.ApiCall?.defaultShareableUserData
  );
  const sharedWithTeam = useSelector((state) => state?.ApiCall?.sharedWithTeam);
  const shareableUserData = useSelector(
    (state) => state.ApiCall.shareableUserData
  );
  const passwordLoader = useSelector((state) => state.ApiCall.passwordLoader);
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );

  const [selectedUserId, setSelectedUserId] = useState([]);
  const [deselectId, setDeselectId] = useState([]);
  const [selectedUserData, setSelectedUserData] = useState([]);

  const [sendModalVisible, setSendModalVisible] = useState(false);
  const [indexId, setIndexId] = useState({});

  const [passwordVisible, setPasswordVisible] = useState(
    props?.isModalSaveAndShare
      ? false
      : panes?.[index]?.predefined ||
        !workspace_privileges?.share_dashboard_internal_enabled
      ? true
      : false
  );
  const [teamMemberShow, setTeamMemberShow] = useState(true);
  const [shareAccount, setShareAccount] = useState();
  const [shareMode, setShareMode] = useState("team"); // "team" or "all"
  const [isDoneLoading, setIsDoneLoading] = useState(false);
  const [shareAllAccessType, setShareAllAccessType] = useState(1); // 1 = View Only, 2 = Editor

  const getWindowSize = () => {
    const { innerWidth, innerHeight } = window;
    return { innerWidth, innerHeight };
  };

  const getPageSize = (windowSize) => {
    let currentWindowSize = windowSize?.innerWidth;

    if (currentWindowSize >= 2261) {
      return 21;
    } else if (currentWindowSize < 2261 && currentWindowSize >= 1905) {
      return 18;
    } else if (currentWindowSize < 1905 && currentWindowSize >= 1590) {
      return 15;
    } else if (currentWindowSize < 1590 && currentWindowSize >= 1278) {
      return 12;
    } else if (currentWindowSize < 1278 && currentWindowSize >= 966) {
      return 12;
    } else if (currentWindowSize < 966) {
      return 10;
    }
    return 12;
  };

  const [windowSize, setWindowSize] = useState(getWindowSize());
  const [pageSize, setPageSize] = useState(getPageSize(windowSize));

  const bottomRef = React.useRef();
  useEffect(() => {
    let newData = {};
    defaultShareableUserData?.map((data) => {
      return (newData[data.user_id] = data.access_type);
    });
    setIndexId(newData);
    if (sharedWithTeam) {
      setShareAccount(sharedWithTeam?.team_access);
      // When shared_with_team is true, set shareMode to "all"
      if (sharedWithTeam?.shared_with_team) {
        setShareMode("all");
        setShareAllAccessType(sharedWithTeam?.team_access || 1);
      }
    }
  }, [defaultShareableUserData, sharedWithTeam]);

  useEffect(() => {
    if (shareableUrl) {
      setIsLoading(false);
      setShareableLink(true);
    }
  }, [shareableUrl]);

  useEffect(() => {
    if (selectedUserId == "") {
      setDeselectId("");
    }
    if (selectedUserId == "all") {
      setSendModalVisible(true);
    }
    if (selectedUserId && deselectId == "") {
      shareableUserData?.forEach((d) => {
        selectedUserId?.forEach((e) => {
          if (d.user_id == e) {
            setSendModalVisible(true);
            setSelectedUserData([...selectedUserData, d]);
          }
        });
      });
    }
  }, [selectedUserId]);

  useEffect(() => {
    if (deselectId !== "") {
      selectedUserData?.forEach((d) => {
        if (d.user_id == deselectId) {
          const deletedData = selectedUserData?.filter(
            (d) => d.user_id !== deselectId
          );
          setSelectedUserData(deletedData);
          setDeselectId("");
        }
      });
    }
  }, [deselectId]);

  const handleOk = () => {
    props?.handleChangeShare(false);
  };

  const handleCancel = () => {
    props?.handleChangeShare(false);
    dispatch(setSharableId(null));
    dispatch(setSharedBrands(null));
    let brandsObject = {
      type: "share_modal",
      brands: brands,
      selectBrandValue: selectBrandValue,
      brandCheckedItems: brandCheckedItems,
    };
    dispatch(setGraphPageBrandValue(brandsObject));
    dispatch(setSharableUserData(null));
    dispatch(resetSelectedProfileInfoInShareModal());
  };

  const handleDone = async () => {
    // If "Share with All" is selected, make the API call
    if (shareMode === "all") {
      setIsDoneLoading(true);
      let index = getPaneIndex(panes, activeKey);
      let template_id = shareableData?.template_id
        ? shareableData?.template_id
        : panes?.[index]?.template_id;

      // Create empty array for users when sharing with all
      let newData = {
        template_id: template_id,
        data: [], // Empty array when sharing with all
      };

      let basicObj = getTemplateListBasicObject(
        authParams,
        panes,
        index,
        pageSize,
        graphConditionConfig
      );
      let paneObject = {
        panes: panes,
        activeKey: activeKey,
        type: window.location.pathname === "/schedule" ? "report" : "dashboard",
      };

      if (authParams) {
        await dispatch(
          setShareableModifyUserData(
            basicObj,
            newData,
            "shared with all",
            paneObject,
            1, // share_with_all = 1
            shareAllAccessType // pass access type separately
          )
        );
      }
      setIsDoneLoading(false);
    }

    // Close the modal
    handleCancel();
  };

  const handleBackArrow = () => {
    setSendModalVisible(false);
    dispatch(resetSelectedProfileInfoInShareModal());
  };

  const handleShareFeature = (e, id, i) => {
    let index = getPaneIndex(panes, activeKey);
    let template_id = shareableData?.template_id
      ? shareableData?.template_id
      : panes?.[index]?.template_id;
    setShareAccount(e.target.value);

    let newIndex = { ...indexId };
    newIndex[id] = e.target.value;
    setIndexId(newIndex);

    if (id == "all") {
      var allArrayData = defaultShareableUserData?.map((s) => {
        return { user_id: s.user_id, access_type: e.target.value };
      });
    }

    let newData = {
      template_id: template_id,
      data:
        id == "all"
          ? allArrayData
          : [{ user_id: id, access_type: e.target.value }],
    };

    let basicObj = getTemplateListBasicObject(
      authParams,
      panes,
      index,
      pageSize,
      graphConditionConfig
    );
    let paneObject = {
      panes: panes,
      activeKey: activeKey,
      type: window.location.pathname === "/schedule" ? "report" : "dashboard",
      edited_dashboard_flow: panes?.[index]?.allow_restore
        ? panes?.[index]?.allow_restore
        : false,
    };

    authParams &&
      dispatch(
        setShareableModifyUserData(
          basicObj,
          newData,
          "changed access",
          paneObject,
          shareMode === "all" ? 1 : 0,
          null // no separate access_type for individual user changes
        )
      );

    dispatch(setDefaultSharableUserData());
  };

  const handleRemoveUser = (id, type) => {
    let index = getPaneIndex(panes, activeKey);
    let template_id = shareableData?.template_id
      ? shareableData?.template_id
      : panes?.[index]?.template_id;

    if (id == "all") {
      var allArrayData = defaultShareableUserData?.map((s) => {
        return { user_id: s.user_id, access_type: -1 };
      });
    }

    let newData = {
      template_id: template_id,
      data: id == "all" ? allArrayData : [{ user_id: id, access_type: type }],
    };

    let basicObj = getTemplateListBasicObject(
      authParams,
      panes,
      index,
      pageSize,
      graphConditionConfig
    );
    let paneObject = {
      panes: panes,
      activeKey: activeKey,
      type: window.location.pathname === "/schedule" ? "report" : "dashboard",
      edited_dashboard_flow: panes?.[index]?.allow_restore
        ? panes?.[index]?.allow_restore
        : false,
    };

    authParams &&
      dispatch(
        setShareableModifyUserData(
          basicObj,
          newData,
          "removed",
          paneObject,
          shareMode === "all" ? 1 : 0,
          null // no separate access_type for removal
        )
      );

    dispatch(setDefaultSharableUserData());
  };

  const handleChangeShareSendModal = (value) => {
    setSendModalVisible(value);
  };

  const openLinkGenerator = () => {
    setTeamMemberShow(false);

    setPasswordVisible(true);
    const timer = setTimeout(() => {
      bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 100);
    return () => {
      clearTimeout(timer);
    };
  };

  const showUserList = () => {
    setTeamMemberShow(true);
    setPasswordVisible(false);
  };

  return (
    <Modal
      className={`${
        authParams?.theme_type === "1"
          ? "darkTheme shareModal"
          : "lightTheme shareModal"
      } share-dashboard-modal`}
      title={
        <div className="portlet__title fontSize-16 font-weight500">
          {sendModalVisible && (
            <img
              src={BackArrow}
              className="mr-1"
              style={{ maxWidth: "2rem", marginTop: "-0.3rem" }}
              onClick={handleBackArrow}
              alt="Back Arrow"
            />
          )}
          Share Dashboard
        </div>
      }
      visible={props?.isModalShare}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={null}
      width={580}
      maskClosable={false}
      bodyStyle={{ padding: "0" }}
      // overlayClassName="position-relative"
    >
      {sendModalVisible ? (
        <SendModal
          isModalShare={sendModalVisible}
          handleChangeShare={handleChangeShareSendModal}
          selectedUserId={selectedUserId}
          setSelectedUserId={setSelectedUserId}
          setDeselectId={setDeselectId}
          selectedUserData={selectedUserData}
          shareMode={shareMode}
        />
      ) : (
        <>
          <div
            className="bg__white"
            style={{ borderRadius: "0 0 0.4rem 0.4rem" }}
          >
            {(!panes?.[index]?.predefined || props?.isModalSaveAndShare) &&
            teamMemberShow &&
            workspace_privileges?.share_dashboard_internal_enabled ? (
              <>
                <div style={{ padding: "1.5rem 2rem 0" }}>
                  <div className="w-100 mb-3">
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <label className="portlet-label font-weight500 mb-0">
                        {shareMode === "team"
                          ? "Share with team members"
                          : sharedWithTeam?.shared_with_team
                          ? "Shared with All Users"
                          : "Share with All Users"}
                      </label>
                      <div className="d-flex align-items-center">
                        <span
                          className="text_regular mr-2"
                          style={{ fontSize: "12px" }}
                        >
                          Team Members
                        </span>
                        <Switch
                          checked={shareMode === "all"}
                          onChange={(checked) =>
                            setShareMode(checked ? "all" : "team")
                          }
                          style={{
                            backgroundColor:
                              shareMode === "all" ? "#1890ff" : "#d9d9d9",
                          }}
                          disabled={sharedWithTeam?.shared_with_team}
                        />
                        <span
                          className="text_regular ml-2"
                          style={{ fontSize: "12px" }}
                        >
                          All
                        </span>
                      </div>
                    </div>
                    {shareMode === "team" && (
                      <ShareDropdown
                        setSelectedUserId={setSelectedUserId}
                        setDeselectId={setDeselectId}
                      />
                    )}
                  </div>
                  {shareMode === "team" && (
                    <div
                      className="custom_scroll1 pr-1"
                      style={{ overflowY: "auto", maxHeight: "24.2rem" }}
                    >
                      <ul className="list-group border-0 mt-15">
                        <li className="list-group-item border-0 pl-0 pr-0 pt-0">
                          {sharedWithTeam?.shared_with_team === false &&
                          !defaultShareableUserData ? (
                            <div
                              className="loader text-center w-100"
                              style={{ height: "10rem" }}
                            >
                              <Spin
                                indicator={
                                  <LoadingOutlined
                                    style={{ fontSize: 24 }}
                                    spin
                                  />
                                }
                              />
                            </div>
                          ) : (
                            sharedWithTeam?.shared_with_team === false &&
                            defaultShareableUserData?.map((d, i) => {
                              return (
                                <>
                                  <div
                                    className="d-flex align-items-center justify-content-between"
                                    style={{ padding: "0.5rem 1.5rem" }}
                                  >
                                    <div className="d-flex align-items-center">
                                      <img
                                        src={Profile}
                                        style={{
                                          width: "3rem",
                                          height: "3rem",
                                        }}
                                        className="mr-1"
                                        alt="Share Profile"
                                      />
                                      <div style={{ lineHeight: "1.4rem" }}>
                                        <div className="text_regular">
                                          {d.first_name} {d.last_name}
                                        </div>
                                        <div className="text_regular-gray">
                                          {d.email}
                                        </div>
                                      </div>
                                    </div>
                                    {d.access_type === 3 ? (
                                      <Button
                                        type="primary"
                                        disabled
                                        className="share-owner-btn border-0 font-size12 text_regular"
                                        style={{
                                          width: "9.2rem",
                                          height: "3.5rem",
                                        }}
                                      >
                                        Owner
                                      </Button>
                                    ) : (
                                      <Dropdown
                                        overlay={
                                          <Menu className="text_regular">
                                            <Menu.Item className="text_regular">
                                              <Radio.Group
                                                key={i}
                                                onChange={(value) =>
                                                  handleShareFeature(
                                                    value,
                                                    d.user_id,
                                                    i
                                                  )
                                                }
                                                // defaultValue={d.access_type}
                                                value={indexId[d.user_id]}
                                              >
                                                <Space direction="vertical">
                                                  <Radio
                                                    className="text_regular"
                                                    value={1}
                                                  >
                                                    View Only
                                                  </Radio>
                                                  <Radio
                                                    className="text_regular"
                                                    value={2}
                                                  >
                                                    Editor
                                                  </Radio>
                                                </Space>
                                              </Radio.Group>
                                            </Menu.Item>
                                            <Menu.Item
                                              className="text_regular border-top"
                                              onClick={() =>
                                                handleRemoveUser(d.user_id, -1)
                                              }
                                            >
                                              Remove
                                            </Menu.Item>
                                          </Menu>
                                        }
                                        trigger={["click"]}
                                        placement="bottomRight"
                                        overlayClassName={
                                          authParams?.theme_type === "1"
                                            ? "darkTheme"
                                            : "lightTheme"
                                        }
                                      >
                                        <div
                                          className="border border-color text_regular font-size12 d-flex align-items-center justify-content-between bg__gray cursor-pointer sharable-link-button"
                                          style={{ padding: "0.8rem 1rem" }}
                                        >
                                          {indexId[d.user_id] === 1
                                            ? "View Only"
                                            : "Editor"}
                                          <img
                                            src={
                                              authParams?.theme_type === "1"
                                                ? accoArrowWhite
                                                : accoArrow
                                            }
                                            alt="Arrow"
                                            className="accordionArrow p-0"
                                          />
                                        </div>
                                      </Dropdown>
                                    )}
                                  </div>
                                </>
                              );
                            })
                          )}
                        </li>
                        {/* share with team start - removed the 'Share with everyone' option */}
                      </ul>
                    </div>
                  )}
                  {shareMode === "all" && (
                    <>
                      <div className="p-5" style={{ minHeight: "200px" }}>
                        <div className="text-center">
                          <div className="mb-3">
                            <svg
                              width="48"
                              height="48"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
                                fill="#1890ff"
                              />
                            </svg>
                          </div>
                          <p className="text_regular font-weight500 mb-2 fontSize-16">
                            {sharedWithTeam?.shared_with_team
                              ? "Dashboard has been shared with all users"
                              : "Share with All Users"}
                          </p>
                          <p
                            className="text_regular-gray mb-4"
                            style={{ fontSize: "14px" }}
                          >
                            {sharedWithTeam?.shared_with_team
                              ? "This dashboard has been shared with all users in your organization."
                              : "This dashboard will be shared with all users in your organization."}
                          </p>
                        </div>

                        <div className="d-flex align-items-center justify-content-center">
                          <label className="text_regular mr-3">
                            Access Type:
                          </label>
                          <Dropdown
                            overlay={
                              <Menu className="text_regular">
                                <Menu.Item className="text_regular">
                                  <Radio.Group
                                    onChange={(e) =>
                                      setShareAllAccessType(e.target.value)
                                    }
                                    value={shareAllAccessType}
                                  >
                                    <Space direction="vertical">
                                      <Radio className="text_regular" value={1}>
                                        View Only
                                      </Radio>
                                      <Radio className="text_regular" value={2}>
                                        Editor
                                      </Radio>
                                    </Space>
                                  </Radio.Group>
                                </Menu.Item>
                                {sharedWithTeam?.shared_with_team && (
                                  <Menu.Item
                                    className="text_regular border-top"
                                    onClick={() => setShareAllAccessType(-1)}
                                  >
                                    Remove
                                  </Menu.Item>
                                )}
                              </Menu>
                            }
                            trigger={["click"]}
                            placement="bottomCenter"
                            overlayClassName={
                              authParams?.theme_type === "1"
                                ? "darkTheme"
                                : "lightTheme"
                            }
                          >
                            <div
                              className="border border-color text_regular font-size12 d-flex align-items-center justify-content-between bg__gray cursor-pointer sharable-link-button"
                              style={{ padding: "0.8rem 1rem", width: "150px" }}
                            >
                              {shareAllAccessType === 1
                                ? "View Only"
                                : shareAllAccessType === 2
                                ? "Editor"
                                : shareAllAccessType === -1
                                ? "Remove"
                                : "View Only"}
                              <img
                                src={
                                  authParams?.theme_type === "1"
                                    ? accoArrowWhite
                                    : accoArrow
                                }
                                alt="Arrow"
                                className="accordionArrow p-0"
                              />
                            </div>
                          </Dropdown>
                        </div>
                      </div>
                      <div
                        className="w-100 text-right bg__white border-top border-color p-15"
                        style={{ borderRadius: "0 0 0.4rem 0.4rem" }}
                      >
                        <Button
                          type="primary"
                          className="ant-btn-primary_blue"
                          onClick={handleDone}
                          loading={isDoneLoading}
                        >
                          Done
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              </>
            ) : (
              <div
                onClick={showUserList}
                className={
                  sharedWithTeam?.shared_with_team === false
                    ? "sharable-link-scrollable-css custom_scroll p-15 pb-0"
                    : ""
                }
              >
                {sharedWithTeam?.shared_with_team === false ? (
                  workspace_privileges?.share_dashboard_internal_enabled &&
                  defaultShareableUserData?.map((d, i) => {
                    return (
                      <>
                        <span className="align-items-center mr-1 d-inline-flex">
                          <img
                            src={Profile}
                            style={{ width: "2.5rem", height: "2.5rem" }}
                            className="mr-1"
                            alt="Shared Profile"
                          />
                          <span className="text_regular">
                            {d.first_name} {d.last_name}
                          </span>
                        </span>
                        {i !== defaultShareableUserData.length - 1 ? " " : ""}{" "}
                      </>
                    );
                  })
                ) : (
                  <li className="list-group-item border-0 pl-0 pr-0 pt-0">
                    <div
                      className="d-flex align-items-center justify-content-between"
                      style={{ padding: "0.5rem 0" }}
                    >
                      <div className="d-flex align-items-center">
                        <img
                          src={logo}
                          style={{
                            width: "2.5rem",
                            height: "2.5rem",
                          }}
                          className="mr-1"
                          alt="Share Profile"
                        />
                        <div style={{ lineHeight: "1.4rem" }}>
                          <div className="text_regular">
                            Share With Everyone
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                )}
              </div>
            )}
            {/* <div className="mb-15"></div> */}
          </div>
          {workspace_privileges?.share_dashboard_public_enabled && (
            <div
              className={`bg__white border-radius-4`}
              style={{
                marginTop: props?.isModalSaveAndShare
                  ? "1rem"
                  : panes?.[index]?.predefined ||
                    !workspace_privileges?.share_dashboard_internal_enabled
                  ? "-5rem"
                  : "1rem",
              }}
            >
              <div
                className={`w-100 ${
                  !passwordVisible
                    ? "d-flex align-items-center justify-centet-between"
                    : ""
                }`}
              >
                <p
                  className={`text_regular font-weight500 ${
                    passwordVisible ? "pt-15 pl-15 pr-15" : "p-15"
                  } fontSize-14 w-100`}
                  style={{ marginBottom: !passwordVisible ? "0" : "" }}
                >
                  Shareable link
                </p>
                {passwordVisible ? (
                  <SharePassword bottom={bottomRef} />
                ) : (
                  <div className="text-right w-100 pr-15 pl-15">
                    <Button
                      ghost
                      className={`ant-btn-primary_blue`}
                      onClick={openLinkGenerator}
                    >
                      Open Link Generator
                    </Button>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </Modal>
  );
};

export default memo(ShareModal);
